export function ucFirst(str) {
    const response = str.charAt(0).toUpperCase() + str.slice(1);

    return response
}